export const sdgsIcons = {
  'SDG 1': { src: '/assets/images/sdg-icons/sdg1.svg' },
  'SDG 2': { src: '/assets/images/sdg-icons/sdg2.svg' },
  'SDG 3': { src: '/assets/images/sdg-icons/sdg3.svg' },
  'SDG 4': { src: '/assets/images/sdg-icons/sdg4.svg' },
  'SDG 5': { src: '/assets/images/sdg-icons/sdg5.svg' },
  'SDG 6': { src: '/assets/images/sdg-icons/sdg6.svg' },
  'SDG 7': { src: '/assets/images/sdg-icons/sdg7.svg' },
  'SDG 8': { src: '/assets/images/sdg-icons/sdg8.svg' },
  'SDG 9': { src: '/assets/images/sdg-icons/sdg9.svg' },
  'SDG 10': { src: '/assets/images/sdg-icons/sdg10.svg' },
  'SDG 11': { src: '/assets/images/sdg-icons/sdg11.svg' },
  'SDG 12': { src: '/assets/images/sdg-icons/sdg12.svg' },
  'SDG 13': { src: '/assets/images/sdg-icons/sdg13.svg' },
  'SDG 14': { src: '/assets/images/sdg-icons/sdg14.svg' },
  'SDG 15': { src: '/assets/images/sdg-icons/sdg15.svg' },
  'SDG 16': { src: '/assets/images/sdg-icons/sdg16.svg' },
  'SDG 17': { src: '/assets/images/sdg-icons/sdg17.svg' },
};

export const periods = [
  {
    label: 'Week',
    value: 'week',
  },
  {
    label: 'Month',
    value: 'month',
  },
  {
    label: 'Quarter',
    value: 'quarter',
  },
  {
    label: 'Year',
    value: 'year',
  },
];

export const colors = {
  'SDG 1': '#EB1C2D',
  'SDG 2': '#D3A029',
  'SDG 3': '#279B48',
  'SDG 4': '#C31F33',
  'SDG 5': '#EF402B',
  'SDG 6': '#00AED9',
  'SDG 7': '#FDB713',
  'SDG 8': '#952843',
  'SDG 9': '#F36D25',
  'SDG 10': '#E11484',
  'SDG 11': '#F99D26',
  'SDG 12': '#CF8D2A',
  'SDG 13': '#48773E',
  'SDG 14': '#007DBC',
  'SDG 15': '#3EB049',
  'SDG 16': '#02558B',
  'SDG 17': '#183668',
};
